var map = {
	"./android-chrome-192x192.png": 173,
	"./apple-touch-icon-114x114.png": 174,
	"./apple-touch-icon-120x120.png": 175,
	"./apple-touch-icon-144x144.png": 176,
	"./apple-touch-icon-152x152.png": 177,
	"./apple-touch-icon-180x180.png": 178,
	"./apple-touch-icon-57x57.png": 179,
	"./apple-touch-icon-60x60.png": 180,
	"./apple-touch-icon-72x72.png": 181,
	"./apple-touch-icon-76x76.png": 182,
	"./favicon-16x16.png": 183,
	"./favicon-32x32.png": 184,
	"./favicon-96x96.png": 185,
	"./manifest.json": 186,
	"./safari-pinned-tab.svg": 187
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;


//////////////////
// WEBPACK FOOTER
// ./images/favicons \.(svg|png|ico|xml|json)$
// module id = 172
// module chunks = 0